var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAsanaMark = function SvgAsanaMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "38px",
    viewBox: "0 0 41 38",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "asana-fdf167fc932f88e8d5083cb3559b373cad45d248c5ad26ebf93be901da06f78d")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.801515152,29.3424242 C0.801307602,32.4667931 2.46794675,35.3539396 5.17362576,36.9163037 C7.87930476,38.4786679 11.2129666,38.4788893 13.9188531,36.9168845 C16.6247396,35.3548798 18.2917622,32.4679547 18.2919697,29.3435859 C18.2922904,24.5137303 14.3771788,20.5980987 9.54732323,20.5977779 C4.71746763,20.5974571 0.801835995,24.5125686 0.801515152,29.3424242 M23.5262121,29.3424242 C23.5262121,32.4665856 25.1929322,35.3534297 27.8985353,36.9155104 C30.6041384,38.4775911 33.9375788,38.4775911 36.6431819,36.9155104 C39.3487849,35.3534297 41.0155051,32.4665856 41.0155051,29.3424242 C41.0155051,24.5112626 37.1008586,20.5977778 32.2708586,20.5977778 C27.4408586,20.5977778 23.5262121,24.5112626 23.5262121,29.3424242 M12.1632828,9.66232323 C12.089735,12.8345285 13.7398832,15.7977969 16.4753484,17.4057538 C19.2108136,19.0137106 22.6025608,19.0141612 25.3384531,17.4069311 C28.0743454,15.7997011 29.7252808,12.8368711 29.6525758,9.66464646 C29.5581495,4.90280603 25.6712637,1.09172586 20.9084871,1.09109323 C16.1457106,1.0904606 12.2578125,4.90050805 12.1621212,9.66232323",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HS-home-page-refresh-2020_test",
    transform: "translate(-192.000000, -6479.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(155.000000, 6440.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asana-fdf167fc932f88e8d5083cb3559b373cad45d248c5ad26ebf93be901da06f78d",
    transform: "translate(36.416667, 38.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "0.801515152 0.917676768 41.0155051 0.917676768 41.0155051 38.0893939 0.801515152 38.0893939"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAsanaMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/asana-mark.afb1bd7f.svg";
export { ForwardRef as ReactComponent };